import { render, staticRenderFns } from "./BasePrices.vue?vue&type=template&id=9386b68c&scoped=true"
import script from "./BasePrices.vue?vue&type=script&lang=js"
export * from "./BasePrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9386b68c",
  null
  
)

export default component.exports